import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import {
  Button,
  Popup,
  Label,
} from 'semantic-ui-react';

const getFormattedNumber = number => {
  const numberFormat = number > 1000000 ? '0.0a' : '0a';
  return numeral(number).format(numberFormat);
};

const NumberComponent = ({ data, count }) => {
  if (data) return (<Label basic color="blue">{getFormattedNumber(count)}</Label>);
  return (<span>{getFormattedNumber(count)}</span>);
};

const InfluencerTableSocialLink = props => {
  if (!props.count) {
    return <div>-</div>;
  }

  return (
    <Popup
      hoverable
      trigger={<NumberComponent data={props.data} count={props.count} />}
    >
      <Button
        color={props.link.color}
        onClick={() =>
          window.open(
            `${props.link.href}${props.link.handle}`,
            '_blank',
          )}
      >
        { props.link.label }
      </Button>
    </Popup>
  );
};

InfluencerTableSocialLink.defaultProps = {
  count: 0,
  link: {
    handle: null,
    color: null,
    label: null,
    href: null,
  },
};


InfluencerTableSocialLink.propTypes = {
  count: PropTypes.number,
  link: PropTypes.object,
  data: PropTypes.object,
};

export default InfluencerTableSocialLink;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-table-social-link/index.js
 **/